import { Col, Input, Row } from "reactstrap"
import styles from "./AccountDeletion.module.scss"
import PrimaryButton from "../../../../components/common/PrimaryButton/PrimaryButton"
import { useState } from "react"
import OrderPlacedTick from "../../../../assets/images/cart/OrderPlacedTick.png"
import Tick from "../../../../assets/images/cart/Vector.png"

const AccountDeletion = () => {
  const [accountDeletionRequest, setAccountDeletionRequest] = useState(false)

  return (
    <div>
      {accountDeletionRequest ? (
        <div className={styles.wrapper}>
          <div className={styles.tick}>
            <img src={OrderPlacedTick} alt="" />
            <img src={Tick} alt="" />
          </div>
          <div>You Account Deletion/Deactivation request is submitted.</div>
          <div className="text-muted text-center">You will be notified after verification.</div>
        </div>
      ) : (
        <Row noGutters>
          <Col xs="12" sm='12' md='12' lg='4' xl='4'>
            <div className={`${styles["text-yellow"]} shadow-sm`}>
              Maelano will conduct ID verification, Account Order completion and Wallet Balance settlement verifications first and then will delete or
              deactivate your account. <span className="fw-semibold">Note:</span> Account will <span className={styles["text-orange"]}>not be recoverable</span>{" "}
              once deleted
            </div>

            <div className="mt-3 p-3 shadow">
              <div>
                <label htmlFor="email">Email</label>
                <Input id="email" name="email" placeholder="Enter email" />
              </div>

              <div className="mt-2">
                <label htmlFor="selectAction">Select action</label>
                <div className="d-flex gap-3 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <input type="radio" name="action" className={styles.input} /> <div>Deactivation</div>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <input type="radio" name="action" className={styles.input} /> <div>Deletion</div>
                  </div>
                </div>
              </div>

              <div className="mt-2">
                <label htmlFor="reason">Reason</label>
                <div className="d-flex gap-2 align-items-center">
                <div><input type="radio" name="reason" className={styles.input} /></div> <div>I have a duplicate account</div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <div><input type="radio" name="reason" className={styles.input} /></div> <div>I am not confident about the privacy of my personal data </div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                <div><input type="radio" name="reason" className={styles.input} /></div> <div>I no more want to use Maelano</div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                <div><input type="radio" name="reason" className={styles.input} /></div> <div>Other</div>
                </div>
              </div>
            </div>
            <div className="text-center mt-3">
              <PrimaryButton name={"Submit Request"} onClick={() => setAccountDeletionRequest(true)} />
            </div>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default AccountDeletion
